@for (toast of toasts; track toast.opts.id) {
  <udex-toast
    #toastEl
    class="dcp-toast"
    value-state="Action"
    placement="BottomCenter"
    [showCloseIcon]="toast.opts?.showCloseIcon"
    [duration]="toast.opts?.duration"
    [valueState]="toast.opts?.type"
    popover="manual"
    desktop
  >
    {{(toast?.message | cxTranslate) || toast?.message}}
  </udex-toast>
}
